import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'gb-empty-state-bag',
  templateUrl: './gb-empty-state-bag.component.html',
  styleUrls: ['./gb-empty-state-bag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbEmptyStateBagComponent {}
